export { default } from './use-delete-record'
